
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.752 8.692a1 1 0 00-1.415-1.413l-25.57 24.56-.008.008L7.3 46.057a1 1 0 00-.006 1.42l1.26 1.26a1 1 0 001.42-.006l14.22-14.45.008-.009 24.55-25.58zM52.651 12.713a1 1 0 00-1.413-1.414l-25.58 24.56-.009.008-14.46 14.21a1 1 0 000 1.426l.634.624.624.634a1 1 0 001.426 0l14.21-14.46.009-.008 24.56-25.58z"}})])
          )
        }
      }
    